import {DocumentBase} from './DocumentBase';
import {ProjectSizeCategoryDto, IndustryDto, UserDto, BusinessLineDto} from '../services/generated';
import {ProcessMinimum} from './ProcessMinimum';
import { DocumentPerProcessUsedDto } from '../services/generated/models/DocumentPerProcessUsedDto';

export class DocumentPerProcess extends DocumentBase implements DocumentPerProcessUsedDto {
  public ownerProcessId: number;
  public projectSizeCategories: ProjectSizeCategoryDto[] | null;
  public industries: IndustryDto[] | null;
  public process: ProcessMinimum | null;
  public auditable: boolean;
  public created: string | null;
  public createdBy: UserDto | null;
  public modified: string | null;
  public modifiedBy: UserDto | null;
  public businessLines: BusinessLineDto[] | null;
  public keyWords: string[] | null;
  public processOwner: UserDto | null;
  public secondaryProcessOwners: Array<UserDto> | null;
  public isInherited: boolean = false;
  public isFavorite: boolean;
  public nextConfirmationDate: string | null;

  constructor(document: DocumentPerProcessUsedDto) {
    super(document);
    this.ownerProcessId = document.ownerProcessId;
    this.projectSizeCategories = document.projectSizeCategories;
    this.industries = document.industries;
    this.process = document.process ? new ProcessMinimum(document.process) : null;
    this.auditable = document.auditable;
    this.nextConfirmationDate = document.nextConfirmationDate;
    this.processOwner = document.processOwner;
    this.secondaryProcessOwners = document.secondaryProcessOwners;
    this.isInherited = document.isInherited;
    this.created = document.created;
    this.createdBy = document.createdBy;
    this.modified = document.modified;
    this.modifiedBy = document.modifiedBy;
    this.businessLines = document.businessLines;
    this.keyWords = document.keyWords;
    this.isFavorite = document.isFavorite;
  }
}
